import {
	AuthSubmit,
	AuthSubmitContent,
	AuthSubmitSpinner,
} from '../../authModal.styles';
import { AUTH_STEPS } from '../constants/authForm.constants';
import AuthCheckIcon from './AuthCheckIcon';

const getButtonText = ({ currentStep, mode, translations }) => {
	if (currentStep === AUTH_STEPS.EMAIL) {
		return mode === 'register'
			? translations.registerButton || 'Register'
			: translations.loginButton || 'Log In';
	}

	if (currentStep === AUTH_STEPS.PASSWORD_LOGIN) {
		return translations.loginButton || 'Log In';
	}

	if (currentStep === AUTH_STEPS.PASSWORD_REGISTER) {
		return translations.registerButton || 'Register';
	}

	if (currentStep === AUTH_STEPS.PASSWORD_SET) {
		return translations.setPasswordButton || 'Set password';
	}

	return 'Next';
};

const AuthFormSubmitButton = ({
	currentStep,
	mode,
	isCheckEmailLoading,
	isAuthPending,
	isAuthSuccess,
	isSubmitDisabled,
	translations,
}) => {
	const getSubmitContent = () => {
		if (isAuthSuccess) {
			return (
				<AuthSubmitContent>
					<AuthCheckIcon />
					{currentStep === AUTH_STEPS.PASSWORD_REGISTER
						? translations.registerSuccessButton
						: translations.loginSuccessButton}
				</AuthSubmitContent>
			);
		}

		if (isCheckEmailLoading) {
			return (
				<AuthSubmitContent>
					<AuthSubmitSpinner />
					{translations.checkingEmail}
				</AuthSubmitContent>
			);
		}

		if (isAuthPending) {
			return (
				<AuthSubmitContent>
					<AuthSubmitSpinner />
					{currentStep === AUTH_STEPS.PASSWORD_REGISTER
						? translations.registering
						: translations.loggingIn}
				</AuthSubmitContent>
			);
		}

		return getButtonText({ currentStep, mode, translations });
	};

	return (
		<AuthSubmit type="submit" disabled={isSubmitDisabled} $success={isAuthSuccess}>
			{getSubmitContent()}
		</AuthSubmit>
	);
};

export default AuthFormSubmitButton;
